






























import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    name: { type: String, required: true },
    to: { type: String, required: false },
    items: { type: Array, required: false, deafult: () => [] },
  },
  setup(props) {
    const hasItems = computed(() => {
      return props.items && props.items.length > 0;
    });

    return { hasItems };
  },
  data() {
    return {
      show: false,
    };
  },
});
